
    <p class="input-title" *ngIf="title">{{ title }}</p>
    <input
      class="form-input {{ customClass }}{{noValidate ? 'ignore-valid' : ''}}"
      [type]="type"
      [placeholder]="placeholder"
      [(ngModel)]="value"
      [attr.checked]="value"
      (blur)="onBlur()"
      [maxlength]="maxlength"
      [disabled]="disabled"
      [readonly]="readonly"
      autocomplete="off"
    />
    <div class="input-icon-wrapper" *ngIf="showIcons" [class.--eye]="(type === 'password' && eye) || eyeToggler">
      <div class="input-eye" *ngIf="(type === 'password' && eye) || eyeToggler" (click)="toggleEye()">
        <i class="fa fa-eye" *ngIf="!eyeToggler"></i> <i class="fa fa-eye-slash" *ngIf="eyeToggler"></i>
      </div>
    </div>
    <p class="input-error" *ngIf="error">{{ error }}</p>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-input.component.ts.FormInputComponent.html